module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#news",
      toString: function () {
        return this.url;
      }
    }